import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
	static targets = [
		"subtotal",
		"total",
		"balance",
		"currencyCode",
		"item",
		"discountType",
		"discountValue",
		"currency",
		"tax",
	];

	updateTotal() {
		let total = this.itemTargets.reduce((acc, item) => {
			const controller = this.application.getControllerForElementAndIdentifier(
				item,
				"invoices--item",
			);
			return acc + controller.total();
		}, 0);

		const discount = Number(this.discountValueTarget.value);
		let discountAmount = 0;

		if (this.discountTypeTarget.value === "percent") {
			discountAmount = (total * discount) / 100;
		} else if (this.discountTypeTarget.value === "amount") {
			discountAmount = discount;
		}

		const taxAmount = this.taxTargets.reduce((acc, tax) => {
			const taxValue = Number(tax.options[tax.selectedIndex].dataset.value);

			if (!isNaN(taxValue) && taxValue > 0) {
				return acc + (total - discountAmount) * (taxValue / 100);
			}

			return acc;
		}, 0);

		this.subtotalTarget.innerText = total.toFixed(2);

		total = total - discountAmount + taxAmount;

		this.totalTargets.forEach((el) => (el.innerText = total.toFixed(2)));
		this.balanceTargets.forEach((el) => (el.innerText = total.toFixed(2)));
		this.setCurrency();
	}

	setCurrency() {
		this.currencyCodeTargets.forEach((currency) => {
			currency.textContent = this.currencyTarget.value;
		});
	}
}
